---
title: First Steps After Login
slug: first_steps
order: 2
---

# First Steps After Login

Welcome to the Norscom Automation Platform! This guide will help you get oriented with the interface and start exploring the platform's capabilities.

## 🏠 **Your Dashboard**

After logging in, you'll land on your personalized dashboard that provides an overview of your automation environment:

### **Key Dashboard Elements**
- **Welcome Header**: Shows your username and current status
- **Navigation Menu**: Access to all platform features

## 🧭 **Navigation Basics**

### **Main Menu Structure**
The platform is organized into logical sections accessible from the left navigation panel:

- **🔄 Process Automation**: Workflow management and execution
- **⚙️ Configuration**: System settings and connections
- **🔐 Security**: User and role management


## 🚀 **Getting Started with Workflows**

### **1. Explore Existing Workflows**
- Navigate to **Process Automation → Node Definitions**
- Browse existing node and flow definitions
- Click on any workflow to see its structure and details

### **2. View Workflow Instances**
- Go to **Process Automation → Node Instances**
- See currently running and completed workflows
- Monitor execution status and results


## 📋 **Understanding Your Permissions**

### **Role-Based Access**
- Your dashboard and menu items are filtered based on your user role
- You'll only see features and data you're authorized to access
- Contact your administrator if you need access to additional features

### **Multi-Zone Access**
- If you have access to multiple zones, you'll see zone-specific information
- Each zone may have different workflows and configurations


### **Browser Compatibility**
- Works best with modern browsers (Chrome, Firefox, Safari, Edge)
- Enable JavaScript for full functionality
- Clear browser cache if you experience display issues

## 🆘 **Getting Help**

### **Support**
- **Norscom Support**: Reach out to [support@norscom.com](mailto:support@norscom.com) 
